const PLATFORMS={
    DIVAR:{
        NAME:"دیوار",
        ID:"v11dW62X4kaZ2Hn4",
        APPS:{
            DIVAR_INTERNAL_AUTH:{
                ID:"DivarInternalAuth",
                TITLE:"احراز هویت داخلی",
            },
            DIVAR_INTERNAL_ESTATE:{
                ID:"DivarInternalEstate",
                TITLE:"اصالت سند ملکی",
            },
            DIVAR_INTERNAL_CAR:{
              ID:"DivarInternalCar",
              TITLE:"تایید اصالت خودرو"
            },
            BUSINESS_LICENSE_INQUIRY:{
                ID:"BusinessLicenseInquiry",
                TITLE:"استعلام مجوز کسب و کار",
                GUIDE_KEY: "BusinessLicenseInquiry_pre_msg"
            },
            FOREIGNER_AUTH:{
                ID:"ForeignerAuth",
                TITLE:"بررسی هویت اتباع"
            },
            I_AUTH:{
                ID:"IAuth",
                TITLE:"تایید هویت",
                GUIDE_KEY:"ia_pre_msg"
            },
            POLICE_CLEARANCE:{
                ID:"PoliceClearance",
                TITLE:"تایید عدم سو پیشینه و احراز هویت",
                GUIDE_KEY: "PoliceClearance_pre_msg"
            },
            ESTATE:{
                ID:"Estate",
                TITLE:"استعلام سند ملکی",
                GUIDE_KEY:"estate_pre_msg"
            },
            C_SERVICE:{
                ID:"CService",
                TITLE:"گواهی اصالت خودرو",
                GUIDE_KEY:"CService_pre_msgs"
            },
            ORIGINALITY_DEVICE:{
                ID:"OriginalityDevice",
                TITLE:"تایید اصالت موبایل و تبلت",
                GUIDE_KEY:"originality_device_pre_msgs"
            },
            TRANSACTIONAL_CREDIT :{
                ID:"TransactionalCredit",
                TITLE:"استعلام اعتبار معاملاتی",
                GUIDE_KEY:null,
                GUIDE_SLIDE:{
                    title: 'ونیفای',
                    description: 'پس از تطابق کدملی و مالکیت شماره همراه در صورت عدم ممنوعیت معاملاتی تاییدیه‌ای مبنی بر آن روی آگهی درج خواهد شد.',
                    subTitle: 'استعلام وضعیت معاملاتی'
                }
            },
            COMPANY_APPROVAL:{
                ID:"CompanyApproval",
                TITLE:"احراز هویت حقوقی ونیفای",
                GUIDE_KEY:"company_approval_pre_msgs",
                STEPS:{
                    INIT_CONFIRM:"InitConfirm",
                    CREATE_PAYMENT: "CreatePayment",
                    PAYMENT_INQUIRY:"InquiryPayment",
                    SHAHKAR:"Shahkar",
                    COMPANY_BUSINESS_LICENSE_INQUIRY:"CompanyBusinessLicenseInquiry",
                    FINAL:"Final"


                }


            },
            FIN_CHECK:{
                ID:"FinCheck",
                TITLE:"خوش حسابی بانکی",
                GUIDE_KEY:"fincheck_pre_msgs",
                STEPS:{
                    INIT_CONFIRM:"InitConfirm",
                    CREATE_PAYMENT:"CreatePayment",
                    PAYMENT_INQUIRY:"InquiryPayment",
                    SHAHKAR:"Shahkar",
                    BANKING_OTP_SEND:"BankingOTPSend",
                    BANKING_OTP_VERIFY:"BankingOTPVerify",
                    BACK_CHEQUES_INQUIRY:"BackChequesInquiry",
                    FACILITY_INQUIRY:"FacilityInquiry",
                    FINAL:"Final",
                }
            }
        }
    },
    TOSAN:{
        NAME:"توسن",
        ID:"1f141fx61m125c13A",
        APPS:{
            BILLS:{
                ID:"Bills",
                TITLE:"افزونه قبض"
            }
        }
    }
}
export default PLATFORMS;